export default "__VITE_ASSET__CfUynowG__"